export const SliderData = [
  {
    image: "https://i.ytimg.com/vi/se_D6dgP65k/maxresdefault.jpg",
  },
  {
    image:
      "https://www.aucegypt.edu/sites/default/files/styles/banner/public/2020-03/shutterstock_1452524699.jpg?itok=3cMMjlN-",
  },
  {
    image:
      "https://www.brown.edu/campus-life/health/services/promotion/sites/healthpromo/files/self-care%20for%20stress%20relief%20webpage%20banner.png",
  },
];
